/**
 * [INPUT]: 依赖运营输入的 Markdown 正文字符串与 20KB 产品上限
 * [OUTPUT]: 对外提供公告正文长度、原始 HTML 和图片语法的统一校验结果
 * [POS]: admin-web/lib 的纯内容策略，供公告页面与真实 HTTP adapter 共享且不依赖 React/传输层
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
const MAX_BODY_BYTES = 20 * 1024;

export function validateAnnouncementBody(bodyMarkdown: string): string {
  const body = bodyMarkdown.trim();
  if (!body || new TextEncoder().encode(body).length > MAX_BODY_BYTES) return '公告正文不能为空且不能超过 20KB。';
  if (containsRawHTML(body)) return '公告正文不允许原始 HTML。';
  if (containsMarkdownImage(body)) return '公告正文暂不支持图片语法。';
  return '';
}

function containsRawHTML(markdown: string): boolean {
  for (let index = 0; index < markdown.length; index += 1) {
    if (markdown[index] !== '<' || isEscaped(markdown, index)) continue;
    let rest = markdown.slice(index + 1);
    if (rest.startsWith('!') || rest.startsWith('?')) return true;
    if (rest.startsWith('/')) rest = rest.slice(1);
    if (!rest || !/[A-Za-z]/.test(rest[0] ?? '')) continue;
    const nameEnd = rest.search(/[^A-Za-z0-9-]/);
    if (nameEnd <= 0) continue;
    const next = rest[nameEnd];
    if ((next === '>' || next === '/' || /\s/.test(next)) && rest.slice(nameEnd).includes('>')) return true;
  }
  return false;
}

function containsMarkdownImage(markdown: string): boolean {
  for (let index = 0; index + 1 < markdown.length; index += 1) {
    if (markdown[index] === '!' && markdown[index + 1] === '[' && !isEscaped(markdown, index)) return true;
  }
  return false;
}

function isEscaped(value: string, index: number): boolean {
  let backslashes = 0;
  for (let cursor = index - 1; cursor >= 0 && value[cursor] === '\\'; cursor -= 1) backslashes += 1;
  return backslashes % 2 === 1;
}
